import { localStorage } from "@prismicio/editor-support/DOM"
import { useSyncExternalStore } from "react"
import { z } from "zod"

import { lab } from "../app/constants"

export function setLabDarkMode(darkMode: boolean) {
  const current = readSettings()
  const updated: LabSettings = { ...current, darkMode }
  const newValue = JSON.stringify(updated)

  localStorage.write(lab, newValue)
}

export function useLabDarkMode() {
  return useSyncExternalStore(localStorage.subscribe, readDarkMode)
}

function readSettings(): LabSettings {
  return localStorage.readJSON(lab, labSettingsSchema) ?? { darkMode: false }
}

function readDarkMode(): boolean {
  return readSettings().darkMode
}

const labSettingsSchema = z.object({
  darkMode: z.boolean(),
})

type LabSettings = z.infer<typeof labSettingsSchema>
